<h1 mat-dialog-title>Valid Document Help</h1>

<mat-dialog-content aria-live="polite">
    <h2 class="bofa--heading is-7"><strong><u>Proof of Address documents</u></strong></h2>

    <table mat-table aria-label="Document Requirements Table" [dataSource]="proofOfAddressDocuments" class="mat-elevation-z8">
        <ng-container matColumnDef="document">
            <th scope="col" mat-header-cell *matHeaderCellDef> <strong>Document</strong> </th>
            <td mat-cell *matCellDef="let document"> {{document.name}} </td>
        </ng-container>

        <ng-container matColumnDef="requirements">
            <th scope="col" mat-header-cell *matHeaderCellDef> <strong>Requirements</strong> </th>
            <td mat-cell *matCellDef="let document"> {{document.requirement}} </td>
        </ng-container>

        <ng-container matColumnDef="disclaimer">
            <td mat-footer-cell *matFooterCellDef colspan="2">
                Contact your Bank of America representative if you require additional guidance
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="proofOfAddressColumns">
        </tr>

        <tr mat-row *matRowDef="let row; columns: proofOfAddressColumns;"></tr>
        <tr mat-footer-row *matFooterRowDef="['disclaimer']" class="global-red center-footer"></tr>
    </table>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <div class="is-taller">
        <div class="level">
            <div class="level-item">
                <button mat-stroked-button class="secondary-btn" type="button" (click)="onNoClick()">Close</button>
            </div>
        </div>
    </div>
</mat-dialog-actions>